import React from "react";

const PollingMessage = () => {
    return (
        <div className='oversized_input_wait'>
            <div>please wait</div>
            <div className="spinner"></div>
        </div>
    );
}

export default PollingMessage;